import { apiService } from '@/services/api/apiService';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';

interface Version {
    component: any;

}

interface VersionState {
    data: Version[];
    loading: boolean;
    error: string | null;
}

const PORT = import.meta.env.VITE_USERS_PORT;
const MASTERURL = import.meta.env.VITE_API_USERS_URL;

export const fetchVersion = createAsyncThunk<Version[], void, { rejectValue: string }>(
    'packUnit/fetchVersion',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.get<{ data: Version[] }>(
                '/get_all_release_versions',
                PORT,
                MASTERURL,
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    },
);

export const createVersion = createAsyncThunk<Version, any, { rejectValue: string }>(
    'packUnit/createVersion',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.post<{ data: Version }>(
                '/create_release_versions',
                params,
                PORT,
                MASTERURL,
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    },
);

export const updateVersion = createAsyncThunk<Version, any, { rejectValue: string }>(
    'packUnit/updateVersion',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.put<{ data: Version }>(
                '/update_food_pack_unit',
                params,
                PORT,
                MASTERURL,
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    },
);
export const softDeleteVersion = createAsyncThunk<{ id: number }, number, { rejectValue: string }>(
    'packUnit/softDeleteVersion',
    async (id, { rejectWithValue }) => {
        try {
            const response = await apiService.patch<{ data: { id: number } }>(
                `/soft_delete_food_pack_unit?id=${id}`,
                {},
                PORT,
                MASTERURL,
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error instanceof Error ? error.message : 'An error occurred while deleting pack unit',
            );
        }
    },
);

export const VersionManagementSlice = createSlice({
    name: 'versionManagement',
    initialState: {
        data: [],
        loading: false,
        error: null,
    } as VersionState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchVersion.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchVersion.fulfilled, (state, action: PayloadAction<Version[]>) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchVersion.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            });
    },
});

export default VersionManagementSlice.reducer;
